import { render, staticRenderFns } from "./px_class.vue?vue&type=template&id=8de1999c"
import script from "./px_class.vue?vue&type=script&lang=js"
export * from "./px_class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports